import { ALL_LEADER_GROUPS_QUERY } from '@/modules/companies'
import { useQuery, useSuspenseQuery } from '@apollo/client'
import { useAdmin } from './useAdmin'

function filterByModule<T extends { excludedModules: string[] }>(
  groups: T[],
  module?: string
): T[] {
  if (!module) return groups
  return groups.filter(
    g => !(g.excludedModules ?? []).includes(module)
  )
}

export function useLeaderGroups(module?: string) {
  const isAdmin = useAdmin()
  const { data, loading: groupsLoading } = useQuery(ALL_LEADER_GROUPS_QUERY)

  const allGroups = filterByModule(data?.allLeaderGroups ?? [], module)

  const { myLeaderGroups, defaultLeaderGroup, hasAccess } = {
    myLeaderGroups: allGroups,
    defaultLeaderGroup: allGroups[0] ?? null,
    hasAccess: isAdmin || allGroups.length > 0,
  }

  return { hasAccess, myLeaderGroups, defaultLeaderGroup, groupsLoading }
}

export type UseLeaderGroupsSuspenseReturn = ReturnType<
  typeof useLeaderGroupsSuspense
>

export function useLeaderGroupsSuspense(module?: string) {
  const isAdmin = useAdmin()
  const { data } = useSuspenseQuery(ALL_LEADER_GROUPS_QUERY)

  const allGroups = filterByModule(data?.allLeaderGroups ?? [], module)

  const { myLeaderGroups, defaultLeaderGroup, hasAccess } = {
    myLeaderGroups: allGroups,
    defaultLeaderGroup: allGroups[0] ?? null,
    hasAccess: isAdmin || allGroups.length > 0,
  }

  return { hasAccess, myLeaderGroups, defaultLeaderGroup }
}
